import Vue from 'vue';
import LastSearchItem from './LastSearchItem.vue';
import { navigateWindow } from '@/router/routerUtils';
import SearchItem from '../components/SearchItem.vue';
import { mapState } from 'vuex';
// @todo handle recent views products
export default Vue.extend({
    components: {
        LastSearchItem,
        SearchItem,
    },
    props: {
        result: {
            type: Object,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        recentSearches: {
            type: Array,
            default: [],
        },
        value: {
            type: String,
            default: '',
        },
    },
    methods: {
        goToProduct(fullSlugPath) {
            if (fullSlugPath)
                return navigateWindow(`/category/${fullSlugPath}`);
            return navigateWindow('product');
        },
    },
    computed: {
        ...mapState('categoriesModule', [
            'categoryMap',
        ]),
    }
});
